import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["input"]

    open() {
        if (this.hasInputTarget) {
            this.inputTarget.showPicker();
        } else {
            const input = this.element.querySelector('input');
            if (input) input.showPicker();
        }
    }
}
